import { isObject } from './is_object';

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze#what_is_shallow_freeze
export function deepFreeze<T = unknown>(object: T): Readonly<T> {
  const propNames = Object.getOwnPropertyNames(object);

  for (const name of propNames) {
    const value = (object as object)[name];

    if (isObject(value)) {
      deepFreeze(value);
    }
  }

  return Object.freeze(object);
}
